import React from 'react';
import "./Menu.css";

export default function Menu(params: {
    onAddCallParamsClick: () => void,
    onAddOperationsClick: () => void,
    onEncodeParamsClick: () => void,
    onContractCallClick: () => void,
    onChainSelect: (e: React.ChangeEvent<HTMLSelectElement>) => void,
    helper: string
}) {
    return (
        <div
            className='button-container'
        >
            <select
                onChange={params.onChainSelect}
            >
                <option
                    value={"ethereum"}
                >Ethereum</option>
                <option
                    value={"polygon"}
                >Polygon</option>
            </select>
            <label className='helper-contract-label'>
                Helper Contract Address:
            </label>

            <div className='helper-contract-address'>
                {params.helper}
            </div>
            <div className='top-placeholder'></div>
            <button
                onClick={params.onAddCallParamsClick}
            >
                Add Call Params
            </button>
            <button
                onClick={params.onAddOperationsClick}
            >
                Add Operations
            </button>
            <button
                onClick={params.onEncodeParamsClick}
            >
                Encode Params
            </button>
            <button
                onClick={params.onContractCallClick}
            >
                Contract Call
            </button>
            <div className='top-placeholder'></div>
        </div>
    )
}